<template>
    <div
        class="bg-green-600 text-white text-sm rounded px-4 py-2 shadow-lg"
    >
        ✅ {{ message }}
    </div>
</template>

<script setup>
const props = defineProps({
    message: String
})
</script>